module.exports = require("react-bootstrap/lib/InputGroup");